import { Component, DestroyRef, inject, OnInit, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RemoteConfigState } from '@app/core/firebase/remote-config/remote-config.state';
import { ROUTE_NAMES } from '@app/core/navigation/navigation.constants';
import { PermissionService } from '@app/features/admin/settings/permission/permission.service';
import { TranslocoService } from '@ngneat/transloco';
import { SidebarCommonComponent } from '@shared/components/sidebar/sidebar.component';
import { SealNavigationItem } from '@shipsfocus/seal';
import { filter, tap } from 'rxjs';

@Component({
  selector: 'vessel-reports-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [SidebarCommonComponent]
})
export class VesselReportsSidebarComponent implements OnInit {
  protected readonly translocoService: TranslocoService = inject(TranslocoService);
  protected readonly destroyRef: DestroyRef = inject(DestroyRef);
  protected readonly permissionService: PermissionService = inject(PermissionService);
  protected readonly remoteConfigState: RemoteConfigState = inject(RemoteConfigState);

  menuData: WritableSignal<SealNavigationItem[]> = signal([]);

  ngOnInit(): void {
    this.initMenuData();
    this.translocoService.events$
      .pipe(
        filter((event) => ['translationLoadSuccess', 'langChanged'].includes(event.type)),
        tap(() => this.initMenuData()),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
  initMenuData() {
    const isEnabled = this.remoteConfigState.remoteConfig()?.sidebar_version === 2;
    this.menuData.set([
      {
        id: 'vessel-reports.type',
        title: this.translocoService.translate('ship_interface.report_types'),
        type: 'group',
        classes: {
          title: 'text-primary'
        },
        children: [
          this.permissionService.checkPermission(['noon_report_ship_interface', ['page_access']]) && {
            id: 'type.noon',
            title: this.translocoService.translate('ship_interface.noon_reports'),
            type: 'basic',
            link: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.VESSEL_REPORT_SHIP_INTERFACE}/${ROUTE_NAMES.NOON}`,
            icon: isEnabled ? 'heroicons_outline:sun' : ''
          },
          this.permissionService.checkPermission(['port_report_ship_interface', ['page_access']]) && {
            id: 'type.port',
            title: this.translocoService.translate('ship_interface.port_reports'),
            type: 'basic',
            link: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.VESSEL_REPORT_SHIP_INTERFACE}/${ROUTE_NAMES.PORT}`,
            icon: isEnabled ? 'heroicons_outline:flag' : ''
          },
          this.permissionService.checkPermission(['monthly_rob_ship_interface', ['page_access']]) && {
            id: 'type.rob',
            title: this.translocoService.translate('ship_interface.monthly_rob'),
            type: 'basic',
            link: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.VESSEL_REPORT_SHIP_INTERFACE}/${ROUTE_NAMES.MONTHLY_ROB}`,
            icon: isEnabled ? 'heroicons_outline:calendar' : ''
          }
        ]
      }
    ]);
  }
}
